export const GET_ALL_DEALERS = 'GET_ALL_DEALERS'
export const GET_ALL_DEALERS_SUCCESSFUL = 'GET_ALL_DEALERS_SUCCESSFUL'
export const GET_ALL_DEALERS_ERROR = 'GET_ALL_DEALERS_ERROR'